import React from 'react'
import RootStore from '@App/stores/root-store'

/**
 * A React context that (will) contain all global MobX stores
 */
const rootStore = new RootStore()

export const StoresContext = React.createContext<RootStore>({
    ...rootStore,
})
